import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ContextProvider } from "./core/store/contextProvider";
import { AppThemeProvider } from "./core/store/themeProvider";
import AppRouter from "./AppRouter";

function App() {
  return (
    <ContextProvider>
      <AppThemeProvider>
        <CssBaseline />
        <AppRouter />
      </AppThemeProvider>
    </ContextProvider>
  );
}

export default App;
